import {ActionEnum, RoomLogInterface} from "../interfaces/common";


export function formatAction (roomLogs: Array<RoomLogInterface>, what: string) {
  if (roomLogs.length === 0) {
    return ("-")
  }
  const roomLog = roomLogs[0];
  let action: ActionEnum = ActionEnum.NONE
  if (what === 'outdoor') {
    action = roomLog.outdoor
  } else if (what === 'activity') {
    action = roomLog.activity
  } else {
    return ("Failed lookup")
  }
  let str: string = '-';
  if (action === ActionEnum.NONE) {
    str = "Inte frågat"
  } else if (action === ActionEnum.ASKED) {
    str = "Frågat"
  } else if (action === ActionEnum.ACCEPTED) {
    str = "Genomfört"
  }
  return str
}